import React, {useEffect, useState} from "react";
import BarekamButton, {CalendarButtons} from "../../../../../../components/button";
import BarekamText from "../../../../../../components/text";
import {DateObject} from "react-multi-date-picker";
import {BarekamCalendar, CalendarFilterButtons, HiddenFilterMenuItem} from "./styled";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";
import moment from "moment";
import {MenuItem} from "@mui/material";

const DateFilter = ({minEnteredDate, maxEnteredDate, onFilterChange, noLabel}: DateFilterProps) => {

    useEffect(() => {
        const selectedDates = [];

        if (minEnteredDate) {
            selectedDates.push(moment(minEnteredDate).format('DD/MM/YYYY'));
        }
        if (maxEnteredDate) {
            selectedDates.push(moment(maxEnteredDate).format('DD/MM/YYYY'));
        }

        setDate(selectedDates);
    }, [minEnteredDate, maxEnteredDate])

    const [date, setDate] = useState([] as any[]);

    const [isPastWeek, setIsPastWeek] = useState(false);
    const [isPastMonth, setIsPastMonth] = useState(false);
    const [isPastYear, setIsPastYear] = useState(false);

    function onButtonClick(filterButton: DateRangeButtons) {
        let date: DateObject[];

        switch (filterButton) {
            case DateRangeButtons.PAST_WEEK:
                setIsPastWeek(true);
                setIsPastMonth(false);
                setIsPastYear(false);

                date = [new DateObject().toFirstOfWeek().add('1', 'day'), new DateObject()];
                onFilterChange(date);

                break;
            case DateRangeButtons.PAST_MONTH:
                setIsPastWeek(false);
                setIsPastMonth(true);
                setIsPastYear(false);

                date = [new DateObject().toFirstOfMonth(), new DateObject()];
                onFilterChange(date);

                break;
            case DateRangeButtons.PAST_YEAR:
                setIsPastWeek(false);
                setIsPastMonth(false);
                setIsPastYear(true);

                date = [new DateObject().toFirstOfYear(), new DateObject()];
                onFilterChange(date);

                break;
            default:
                setIsPastWeek(false);
                setIsPastMonth(false);
                setIsPastYear(false);

                date = [];
                onFilterChange(date);
                break;
        }
        setDate(date);
    }

    function onCalendarChange(selectedDates: DateObject[]) {
        setIsPastWeek(false);
        setIsPastMonth(false);
        setIsPastYear(false);

        setDate(selectedDates);

        if (selectedDates.length === 2) {
            onFilterChange(selectedDates);
        }
    }

    function onRemove() {
        setIsPastWeek(false);
        setIsPastMonth(false);
        setIsPastYear(false);

        setDate([]);
        onFilterChange([]);
    }

    return (
        <BarekamSelect
            variant={'outlined'}
            label={noLabel ? undefined : <Message messageKey={'date'} sectionId={MessageSections.ORDERS}/>}
            value={minEnteredDate && maxEnteredDate ? `${minEnteredDate}-${maxEnteredDate}` : 'all'}
            type={"filter"}
            fullWidth
            required>
            <MenuItem onClick={() => onRemove()}
                      value={'all'}
                      key={'all'}>
                <BarekamText variant={'1rem'}>
                    <Message messageKey={"all_time"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>

            {minEnteredDate && maxEnteredDate
                ? <HiddenFilterMenuItem value={`${minEnteredDate}-${maxEnteredDate}`}
                           key={'selected-date'}>
                    <BarekamText variant={"m"}>
                        {moment(minEnteredDate).format('DD/MM/YYYY')} - {moment(maxEnteredDate).format('DD/MM/YYYY')}
                    </BarekamText>
                </HiddenFilterMenuItem>
                : ''
            }

            <BarekamCalendar
                value={date}
                onChange={(selectedDates: DateObject[]) => onCalendarChange(selectedDates)}
                weekStartDayIndex={1}
                range
                rangeHover
                showOtherDays
                displayWeekNumbers
                maxDate={new Date()} 
                shadow={false}>
                <CalendarFilterButtons>
                    <BarekamButton type={CalendarButtons.FILTER} onClick={() => onButtonClick(DateRangeButtons.PAST_WEEK)} selected={isPastWeek}>
                        <BarekamText variant={'xs'}>
                            <Message messageKey='past_week' sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </BarekamButton>

                    <BarekamButton type={CalendarButtons.FILTER} onClick={() => onButtonClick(DateRangeButtons.PAST_MONTH)} selected={isPastMonth}>
                        <BarekamText variant={'xs'}>
                            <Message messageKey='past_month' sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </BarekamButton>

                    <BarekamButton type={CalendarButtons.FILTER} onClick={() => onButtonClick(DateRangeButtons.PAST_YEAR)} selected={isPastYear}>
                        <BarekamText variant={'xs'}>
                            <Message messageKey='past_year' sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </BarekamButton>
                </CalendarFilterButtons>
            </BarekamCalendar>
        </BarekamSelect>
    );
};

export default DateFilter;

export interface DateFilterProps {
    minEnteredDate: number | undefined,
    maxEnteredDate: number | undefined,

    onFilterChange: (dates: DateObject[]) => void;
    noLabel?: boolean;
}

enum DateRangeButtons {
    PAST_WEEK, PAST_MONTH, PAST_YEAR
}